export const SUPPORTED_IMAGE_EXTENSIONS = [
  'jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'webp',
  'heif', 'heic', 'svg', 'ico', 'raw', 'psd',
];

export const SUPPORTED_VIDEO_EXTENSIONS = [
  'mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm',
  'mpeg', 'mpg', '3gp', 'm4v', 'ts',
];

export const SUPPORTED_DOCUMENT_EXTENSIONS = [
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
  'txt', 'rtf', 'odt', 'ods', 'odp', 'csv', 'md',
  'pages', 'numbers', 'key',
];

export const SUPPORTED_SCAN_EXTENSIONS = [
  'dcm', 'dicom', 'nii', 'nii.gz', 'hdr', 'img',
  'mha', 'mhd', 'nrrd', 'gipl', 'mnc',
];

export const SUPPORTED_VOLUME_EXTENSIONS = [
  'stl', 'obj', 'glb', 'gltf',
];

export const MEDIA_CATEGORIES = {
  IMAGE: 'image',
  VIDEO: 'video',
  DOCUMENT: 'document',
  SCAN: 'scan',
  VOLUME: 'volume',
  OTHER: 'other',
} as const;

export type IMediaCategory = typeof MEDIA_CATEGORIES[keyof typeof MEDIA_CATEGORIES];

export const MEDIA_MAX_SIZE_BYTES: Record<IMediaCategory, number> = {
  [MEDIA_CATEGORIES.IMAGE]: 100 * 1024 * 1024, // 100 MB
  [MEDIA_CATEGORIES.VIDEO]: 250 * 1024 * 1024, // 250 MB
  [MEDIA_CATEGORIES.DOCUMENT]: 100 * 1024 * 1024, // 100 MB
  [MEDIA_CATEGORIES.SCAN]: 250 * 1024 * 1024, // 250 MB
  [MEDIA_CATEGORIES.VOLUME]: 250 * 1024 * 1024, // 250 MB
  [MEDIA_CATEGORIES.OTHER]: 100 * 1024 * 1024, // 100 MB
};
